import { Component, computed, HostListener, inject, Input, LOCALE_ID, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { SubcategoryService } from '../../../../services/subcategory/subcategory.service';
import { SubcategoryFileMgt } from '../../../../services/subcategory/fileMgt.subcategory.service';
import { Router } from '@angular/router';
import {
  OneSubcategoryModel,
  SubcategoriesList,
} from '../../../../pages/admin-dashboard/admin-subcategories/admin-subcategories.model';

@Component({
  selector: 'app-view-subcategory-details',
  imports: [],
  templateUrl: './view-subcategory-details.html',
  styleUrl: './view-subcategory-details.scss',
})
export class ViewSubcategoryDetails {
  private locale = inject(LOCALE_ID);
  isArabic = computed(() => this.locale.startsWith('ar'));
  @Input() subcategoryId!: number;

  private subcategoriesService = inject(SubcategoryService);
  private subcategoryFileMgt = inject(SubcategoryFileMgt);
  private router = inject(Router);
  imagePreviewUrl = signal<string>('');

  loading = signal<boolean>(false);
  loadingSubcategories = signal<boolean>(false);
  errorLoadingSubcategory = signal<string | null>(null);

  subcategory: OneSubcategoryModel | null = null;
  subcategories: SubcategoriesList[] = [];
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;
  activeDropdownId = signal<number | null>(null);
  showCategoryDropdown = signal<boolean>(false);
  showDeleteDialog = false;
  showSuccessMessage = false;

  ngOnInit() {
    if (this.subcategoryId) {
      this.loadSubcategory();
      // this.loadSubcategories();
    }
  }

  loadSubcategory() {
    this.loading.set(true);
    this.subcategoriesService
      .getSubcategoryById(this.subcategoryId)
      .pipe(
        finalize(() => {
          this.loading.set(false);
        }),
      )
      .subscribe({
        next: (subcategory: OneSubcategoryModel) => {
          this.subcategory = subcategory;
          this.subcategoryFileMgt.getImage(subcategory.profileImageFid!).subscribe({
            next: (blob: Blob) => {
              const imageUrl = window.URL.createObjectURL(blob);
              this.imagePreviewUrl.set(imageUrl);
            },
            error: () => {},
          });
        },
        error: (err: Error) => {
          console.error('Error loading category:', err);
          this.errorLoadingSubcategory.set('Failed to load category. Please try again.');
        },
      });
  }

  // loadSubcategories() {
  //   this.loadingSubcategories.set(true);

  //   this.subcategoriesService.getAllSubcategories().subscribe({
  //     next: (data: SubcategoriesListResponse) => {
  //       this.subcategories = data.list;
  //     },
  //     error: (error: Error) => {
  //       console.error('Error loading subcategories:', error);
  //     },
  //   });
  // }

  get paginatedSubCategories(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.subcategories.slice(startIndex, endIndex);
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  get startItem(): number {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  get endItem(): number {
    const end = this.currentPage * this.itemsPerPage;
    return end > this.totalItems ? this.totalItems : end;
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxPages = Math.min(this.totalPages, 100);
    for (let i = 1; i <= maxPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  getCategoryImage(): string {
    return 'https://placehold.co/400x400?text=No+Image';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    this.activeDropdownId.set(null);
    this.showCategoryDropdown.set(false);
  }

  toggleDropdown(id: number, event: Event) {
    event.stopPropagation();
    if (this.activeDropdownId() == id) {
      this.activeDropdownId.set(null);
    } else {
      this.activeDropdownId.set(id);
    }
  }

  toggleSubcategoryDropdown(event: Event) {
    event.stopPropagation();
    this.showCategoryDropdown.set(!this.showCategoryDropdown());
  }

  handleCategoryAction(action: string) {
    if (action == 'Edit Category' && this.subcategory) {
      this.router.navigate(['/admin/categories/edit-category', this.subcategory.id]);
    } else if (action == 'Delete Category' && this.subcategory) {
      this.openDeleteDialog();
    }
    this.showCategoryDropdown.set(false);
  }

  openDeleteDialog() {
    this.showDeleteDialog = true;
  }

  closeDeleteDialog() {
    this.showDeleteDialog = false;
  }

  deleteCategory() {
    if (this.subcategory) {
      const deletedId = this.subcategory.id;
      this.closeDeleteDialog();
      this.subcategoriesService.deleteSubcategory(deletedId).subscribe({
        next: () => {
          this.showSuccessMessage = true;
          setTimeout(() => {
            this.showSuccessMessage = false;
            this.router.navigate(['/admin/subcategories']);
          }, 2000);
        },
        error: (error: Error) => {
          console.error('Error deleting subcategory:', error);
        },
      });
    }
  }

  handleAction(action: string, subCategory: any) {
    if (action == 'Edit Sub Category') {
      console.log('Edit sub category:', subCategory.id);
    } else if (action == 'Delete Sub Category') {
      console.log('Delete sub category:', subCategory.id);
    }
    this.activeDropdownId.set(null);
  }

  onAddSubcategory() {
    console.log('Add sub category clicked');
  }
}
